class InstagramController {
  /* @ngInject */
  constructor($rootScope) {
    const vm = this;

    vm.$onInit = () => {
      vm.assets = vm.artist.instagramMedia.slice(0, 18);

      $rootScope.pageTitle = [vm.artist.title, 'Instagram'].join(' — ');
      // $rootScope.pageDescription = ''

      $rootScope.socialImage(vm.assets[0].url);
    };
  }
}

export default InstagramController;
